import React from 'react';

import DataTable, {
  DataTableBody,
  DataTableCell,
  DataTableHead,
  DataTableHeader,
  DataTableRow,
} from '@amzn/meridian/data-table';
import Popover, { PopoverHeader } from '@amzn/meridian/popover';
import Text from '@amzn/meridian/text';
import { type TableDataRow } from 'src/utils/jmrUtils';
import { getRequiredTaskHours, getRequiredTaskPercent } from 'src/utils/placementSelectionUtils';

interface ConflictingTasksPopoverProps {
  selectedJob: TableDataRow;
  exceededRestrictionIds: Set<number>;
  anchorRef: React.MutableRefObject<HTMLElement | null>;
  isOpen: boolean;
  onClose: () => void;
}

const ConflictingTasksPopover = ({
  selectedJob,
  exceededRestrictionIds,
  anchorRef,
  isOpen: open,
  onClose,
}: ConflictingTasksPopoverProps) => {
  const { name, conflicts } = selectedJob;
  const exceededConflicts = conflicts.filter(
    (c) => exceededRestrictionIds.has(c.taskId) && !c.appliedModifications?.length,
  );

  return (
    <Popover
      aria-label={`${name} Restrictions Exceeded Popover`}
      anchorNode={anchorRef.current || undefined}
      position="top"
      {...{ open, onClose }}
    >
      <PopoverHeader closeLabel="Close">Restrictions Exceeded</PopoverHeader>
      <Text>The following job requirements contribute to exceeded restrictions.</Text>
      <DataTable>
        <DataTableHead>
          <DataTableRow>
            <DataTableHeader>Requirement</DataTableHeader>
            <DataTableHeader>Restricted Hrs</DataTableHeader>
            <DataTableHeader>Required %</DataTableHeader>
            <DataTableHeader>Allocated Hrs</DataTableHeader>
          </DataTableRow>
        </DataTableHead>
        <DataTableBody>
          {exceededConflicts.map((ec) => (
            <DataTableRow highlightOnHover={true} key={ec.taskId}>
              <DataTableCell>{ec.taskName}</DataTableCell>
              <DataTableCell>{ec.restrictedValue}</DataTableCell>
              <DataTableCell>{getRequiredTaskPercent(ec).toFixed(1)}%</DataTableCell>
              <DataTableCell>{getRequiredTaskHours(selectedJob, ec).toFixed(1)}</DataTableCell>
            </DataTableRow>
          ))}
        </DataTableBody>
      </DataTable>
    </Popover>
  );
};

export default ConflictingTasksPopover;
